import {ref} from 'vue';
import {defineStore} from 'pinia';
import {Setting} from '~/types/interfaces/entitites/SettingInterface';
import {ErrorInterface} from "~/types/interfaces/ErrorInterface";
import {useCSRF} from "~/stores/csrf";
import {useAPI} from "~/composables/useAPI";

export const useSettingsClient = defineStore('settingsClient', () => {
    //https://pinia.vuejs.org/core-concepts/#setup-stores
    //ref()s become state properties
    const error = ref<ErrorInterface | null>(null);
    const setting = ref<Setting>({} as Setting);
    const useApi = useAPI();
    const csrfStore = useCSRF();

    // computed()s become getters
    const currentSetting = computed(() => setting.value)
    const currentSettingError = computed(() => error.value)

    //function()s become actions
    function setSetting(settingData: Setting) {
        setting.value = settingData;
    }

    function setError(errorData: any) {
        error.value = errorData;
    }

    function resetErrors() {
        error.value = null;
    }

    async function view() {
        await useApi.apiFetch(`/client/config/setting/view`, {
            method: 'GET',
        }).then(({data}) => {
            try {
                setSetting(data);
            } catch (e) {
                console.log("exc", e);
            }

        }).catch(({response}) => {
            if (response) {
                setError(response._data);
            } else {
                console.log("error", response);
                setError({
                        application_code: '',
                        data: {},
                        message: 'No hay conexión',
                        status: 'Error',
                    }
                );
            }
        });
    }


    async function refreshSetting() {
        if (setting.value) {
            await view(setting.value.hash)
        }
    }

    return {
        setting,
        currentSetting,
        currentSettingError,
        resetErrors,
        view,
        refreshSetting
    };
});
